import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.community').config(routesConfig);

    routesConfig.$inject = ['$stateProvider'];

    /* @ngInject */
    function routesConfig($stateProvider) {
        $stateProvider
            .state('community', {
                abstract: true,
                url: '/community',
                data: {
                    authorizedRole: 'USER_BO',
                },
            })
            .state('community.list', {
                abstract: true,
                component: 'contentLayout',
            })
            .state('community.list.main', {
                url: '/list',
                views: {
                    content: {
                        component: 'listCommunities',
                    },
                },
            })
            .state('community.new', {
                abstract: true,
                component: 'communityLayout',
            })
            .state('community.new.create', {
                url: '/create',
                views: {
                    content: {
                        component: 'communityDetail',
                    },
                },
                resolve: {
                    setCommunityEid: setCommunityEid,
                    initMenuCommunity: initMenuCommunity,
                    countries: getCountries,
                },
            })
            .state('community.details', {
                abstract: true,
                url: '/:eid',
                component: 'communityLayout',
                resolve: {
                    setCommunityEid: setCommunityEid,
                    initMenuCommunity: initMenuCommunity,
                    community: getCommunity,
                    documentInfos: getDocumentInfos,
                    legalNotices: getLegalNoticeInfos,
                },
            })
            .state('community.details.main', {
                url: '/main',
                resolve: {
                    countries: getCountries,
                },
                views: {
                    content: {
                        component: 'communityDetail',
                    },
                },
            })
            .state('community.details.personalise', {
                url: '/community-personalise',
                resolve: {
                    brand: getBrand,
                    mode: function () {
                        return 'COMMUNITY';
                    },
                },
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'principalPersonalisePortal',
                    },
                },
            })
            .state('community.details.groupement-create', {
                url: '/cooperative-create',
                resolve: {
                    mode: function () {
                        return 'create';
                    },
                },
                views: {
                    content: {
                        component: 'cooperativeDetail',
                    },
                },
            })
            .state('community.details.groupement-update', {
                url: '/cooperative/:id/details',
                resolve: {
                    cooperative: getCooperative,
                    mode: function () {
                        return 'edit';
                    },
                },
                views: {
                    content: {
                        component: 'cooperativeDetail',
                    },
                },
            })
            .state('community.details.groupement-list', {
                url: '/cooperatives',
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'listCooperativesCommunity',
                    },
                },
            })
            .state('community.details.companies', {
                url: '/companies',
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'listCompaniesCommunity',
                    },
                },
            })
            .state('community.details.portal', {
                url: '/community-portal',
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'communityPortal',
                    },
                },
            })
            .state('community.details.stock-software-list', {
                url: '/community-stock-software',
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'communityStockSoftware',
                    },
                },
            })
            .state('community.details.stock-software-update', {
                url: '/stock-software/:id/details',
                resolve: {
                    stockSoftware: getStockSoftware,
                    countries: getCountries,
                    mode: function () {
                        return 'edit';
                    },
                },
                views: {
                    content: {
                        component: 'stockSoftwareDetail',
                    },
                },
            })
            .state('community.details.stock-software-create', {
                url: '/stock-software/create',
                resolve: {
                    countries: getCountries,
                    mode: function () {
                        return 'create';
                    },
                },
                views: {
                    content: {
                        component: 'stockSoftwareDetail',
                    },
                },
            })
            .state('community.details.referential', {
                url: '/referentials',
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'listReferentialsCommunity',
                    },
                },
            })
            .state('community.details.orders', {
                url: '/orders-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'ORDER',
                    documentModel: getDocumentModel,
                    attributes: getDictionary,
                    sections: getSectionForOrderParam,
                    modelContext: getModelContext,
                    controlSets: getControlSetsOrder,
                    controlSetsCancellation: getControlSetsCancellation,
                },
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'orderParam',
                    },
                },
            })
            .state('community.details.orders-response', {
                url: '/orders-response-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'RESPONSE',
                    documentModel: getDocumentModel,
                    attributes: getDictionary,
                    sections: getSectionForOrderResponseParam,
                    modelContext: getModelContext,
                    controlSets: getControlSetsOrderResponse,
                },
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'responseParam',
                    },
                },
            })
            .state('community.details.desadvparam', {
                url: '/desadv-param',
                resolve: {
                    countries: () => null,
                    ladProviders: () => null,
                    functionalType: () => 'DESADV',
                    documentModel: getDocumentModel,
                    attributes: getDictionary,
                    controlSets: getControlSetsOrder,
                    sections: getSectionForDesadvParam,
                    modelContext: getModelContext,
                },
                views: {
                    communityInfo: {
                        templateUrl: require('./community-info.html'),
                    },
                    content: {
                        component: 'desadvParam',
                    },
                },
            });
    }

    getCountries.$inject = ['CountrySvc'];
    function getCountries(CountrySvc) {
        return CountrySvc.getAll();
    }

    setCommunityEid.$inject = ['$transition$', 'CommunitySvc'];
    function setCommunityEid($transition$, CommunitySvc) {
        return CommunitySvc.setCommunityEid($transition$.params().eid);
    }

    getCommunity.$inject = ['$transition$', 'CommunitySvc'];
    function getCommunity($transition$, CommunitySvc) {
        return CommunitySvc.refreshCommunity($transition$.params().eid);
    }

    initMenuCommunity.$inject = ['CommunitySvc'];
    function initMenuCommunity(CommunitySvc) {
        return CommunitySvc.initMenuCommunity(CommunitySvc.getCommunityEid());
    }
    getStockSoftware.$inject = ['$transition$', 'CommunitySvc'];
    function getStockSoftware($transition$, CommunitySvc) {
        return CommunitySvc.getStockSoftware($transition$.params().id);
    }

    getBrand.$inject = ['$uiRouterGlobals', 'CommunitySvc'];
    function getBrand($uiRouterGlobals, CommunitySvc) {
        return CommunitySvc.getBrand($uiRouterGlobals.params.eid);
    }

    getDocumentInfos.$inject = ['$transition$', 'CommunitySvc'];
    function getDocumentInfos($transition$, CommunitySvc) {
        return CommunitySvc.getCgaInfos($transition$.params().eid);
    }

    getCooperative.$inject = ['$transition$', 'CooperativeSvc'];
    function getCooperative($transition$, CooperativeSvc) {
        return CooperativeSvc.getCooperative($transition$.params().id);
    }

    getDocumentModel.$inject = ['$transition$', 'DocumentModelDA', 'functionalType'];
    function getDocumentModel($transition$, DocumentModelDA, functionalType) {
        return DocumentModelDA.getDocumentModel($transition$.params().eid, functionalType);
    }

    getDictionary.$inject = ['$transition$', 'DocumentModelDA', 'functionalType'];
    function getDictionary($transition$, DocumentModelDA, functionalType) {
        return DocumentModelDA.getDictionary($transition$.params().eid, functionalType);
    }
    getSectionForOrderParam.$inject = ['ORDER_PARAM'];
    function getSectionForOrderParam(ORDER_PARAM) {
        return ORDER_PARAM.sectionsOrder;
    }
    getSectionForOrderResponseParam.$inject = ['ORDER_PARAM'];
    function getSectionForOrderResponseParam(ORDER_PARAM) {
        return ORDER_PARAM.sectionsResponse;
    }
    getSectionForDesadvParam.$inject = ['ORDER_PARAM'];
    function getSectionForDesadvParam(ORDER_PARAM) {
        return ORDER_PARAM.sectionsDesadv;
    }
    getControlSetsOrder.$inject = ['$transition$', 'DocumentModelDA', 'functionalType'];
    function getControlSetsOrder($transition$, DocumentModelDA, functionalType) {
        return DocumentModelDA.getControlSets($transition$.params().eid, functionalType);
    }
    getControlSetsCancellation.$inject = ['$transition$', 'DocumentModelDA'];
    function getControlSetsCancellation($transition$, DocumentModelDA) {
        return DocumentModelDA.getControlSets($transition$.params().eid, 'CANCELLATION');
    }
    getControlSetsOrderResponse.$inject = ['$transition$', 'DocumentModelDA', 'functionalType'];
    function getControlSetsOrderResponse($transition$, DocumentModelDA, functionalType) {
        return DocumentModelDA.getControlSets($transition$.params().eid, functionalType);
    }
    getLegalNoticeInfos.$inject = ['$transition$', 'CommunitySvc'];
    function getLegalNoticeInfos($transition$, CommunitySvc) {
        return CommunitySvc.getLegalNotices($transition$.params().eid);
    }

    getModelContext.$inject = ['$transition$', 'CommunitySvc', 'ModelContext'];
    function getModelContext($transition$, CommunitySvc, ModelContext) {
        return CommunitySvc.refreshCommunity($transition$.params().eid).then(
            community => new ModelContext(community, 'community', false, null),
            () => this.logger.error('error.search')
        );
    }
})();
